var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productdeta-details" },
    [
      _vm.$route.query.isApp != 1
        ? _c("div", { staticClass: "app-down flex-between" }, [
            _c("div", { staticClass: "flex-center" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/images/logo_download.svg"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "download-content" }, [
                _c("p", [_vm._v("SuperEx APP")]),
                _vm._v(" "),
                _c("span", { staticClass: "block" }, [
                  _vm._v(_vm._s(_vm.$t("300261")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-center" }, [
              _c(
                "dl",
                {
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/download",
                        query: { type: "detail" }
                      })
                    }
                  }
                },
                [
                  _c("dt", [
                    _c("svg", [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-xiazaitubiao1" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.$t("300345")))])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.query.isApp != 1
        ? _c("div", { staticClass: "productdeta-header" }, [
            _c("i", {
              staticClass: "iconfont icon-left",
              class: { mirrorRotateLevel: _vm.isDirection },
              on: {
                click: function($event) {
                  return _vm.$router.go(-1)
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "productdeta-main" }, [
        _c(
          "div",
          { staticClass: "swiper-banner" },
          [
            _c(
              "van-swipe",
              { attrs: { autoplay: 3000 } },
              _vm._l(_vm.shopMessage.imgs, function(image, index) {
                return _c("van-swipe-item", { key: index }, [
                  _c("img", { attrs: { src: image } })
                ])
              }),
              1
            ),
            _vm._v(" "),
            _vm.horseLampData.length > 0
              ? _c(
                  "div",
                  { staticClass: "notice-bar" },
                  [
                    _c(
                      "van-swipe",
                      {
                        staticClass: "notice-swipe",
                        attrs: {
                          vertical: "",
                          autoplay: 1500,
                          "show-indicators": false
                        }
                      },
                      _vm._l(_vm.horseLampData, function(item, index) {
                        return _c("van-swipe-item", { key: index }, [
                          _c("img", {
                            class: { mirrorRotateLevel: _vm.isDirection },
                            attrs: {
                              src: require("../../../static/images/congratulations.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(item.message))])
                        ])
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "commodity" }, [
          _c("p", { staticClass: "commodity-name bold" }, [
            _vm._v(_vm._s(_vm.shopMessage.title))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "commodity-oncePrice" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("300300")) + "\n        "),
            _vm._v(" "),
            _c("em", { staticClass: "bold" }, [
              _vm._v(" " + _vm._s(_vm.shopMessage.minPrice))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "currency bold" }, [
              _vm._v(_vm._s(_vm.shopMessage.currency.toUpperCase()))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "oldPrice" }, [
              _vm._v(
                _vm._s(_vm.shopMessage.price) +
                  _vm._s(_vm.shopMessage.currency.toUpperCase())
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Period" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("300338", { num: _vm.shopMessage.roundCount }))
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "rule",
                on: {
                  click: function($event) {
                    return _vm.$router.push({
                      path: "/purchaseRule",
                      query: {
                        token: _vm.$route.query.token,
                        isApp: _vm.$route.query.isApp
                      }
                    })
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("300337")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "commodity-progress-bar" }, [
            _vm.shopMessage.sellCount
              ? _c(
                  "div",
                  {
                    staticClass: "rate-of-progress",
                    style: {
                      width:
                        (_vm.shopMessage.sellCount /
                          (_vm.shopMessage.price / _vm.shopMessage.minPrice)) *
                          100 +
                        "%"
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "progress-img",
                      style: {
                        width:
                          (_vm.shopMessage.sellCount /
                            (_vm.shopMessage.price /
                              _vm.shopMessage.minPrice)) *
                            100 +
                          "%"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "progress-color" })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.shopMessage.sellCount
              ? _c("div", { staticClass: "rate-of-progress" }, [
                  _c("div", { staticClass: "progress-img" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress-color" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "fireImage",
              class: { mirrorRotateLevel: _vm.isDirection },
              attrs: {
                src: require("../../../static/images/firejian.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "commodity-sellNum" }, [
            _vm._v(
              _vm._s(
                _vm.$t("300301", {
                  num: _vm.shopMessage.sellCount,
                  price: _vm.shopMessage.price,
                  currency: _vm.shopMessage.currency.toUpperCase()
                })
              )
            )
          ]),
          _vm._v(" "),
          _vm.shopMessage.roundCount > 1
            ? _c(
                "div",
                {
                  staticClass: "announced-in-the-past",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/previous",
                        query: {
                          token: _vm.$route.query.token,
                          isApp: _vm.$route.query.isApp,
                          mallProductId: _vm.shopMessage.mallProductId
                        }
                      })
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("300335")))]),
                  _vm._v(" "),
                  _vm.prizeMsgList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "announced" },
                        [
                          _c(
                            "van-swipe",
                            {
                              staticClass: "announced-swipe",
                              attrs: {
                                vertical: "",
                                autoplay: 1500,
                                "show-indicators": false
                              }
                            },
                            _vm._l(_vm.prizeMsgList, function(item, index) {
                              return _c("van-swipe-item", { key: index }, [
                                _c("img", {
                                  class: { mirrorRotateLevel: _vm.isDirection },
                                  attrs: {
                                    src: require("../../../static/images/congratulations.png"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(item.message))])
                              ])
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "iconfont icon-left",
                    class: { mirrorRotateLevel: !_vm.isDirection }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "Purchase-process" }, [
            _c("div", { staticClass: "process-top" }),
            _vm._v(" "),
            _c("div", { staticClass: "process-bottom" }),
            _vm._v(" "),
            _c("div", { staticClass: "process-content" }, [
              _c("p", { staticClass: "bold" }, [
                _c("svg", [
                  _c("use", {
                    attrs: { "xlink:href": "#icon-shangpinjieshaozuo" }
                  })
                ]),
                _vm._v(_vm._s(_vm.$t("300339")) + "\n            "),
                _c("svg", { staticClass: "mirrorRotateLevel" }, [
                  _c("use", {
                    attrs: { "xlink:href": "#icon-shangpinjieshaozuo" }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowPath" }, [
                _c("dl", [
                  _c("dt", [
                    _c("svg", [
                      _c("use", { attrs: { "xlink:href": "#icon-canyu" } })
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "iconfont" })
                  ]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.$t("300294")))])
                ]),
                _vm._v(" "),
                _c("p", { class: { mirrorRotateLevel: _vm.isDirection } }, [
                  _c("svg", [
                    _c("use", { attrs: { "xlink:href": "#icon-jiantou2" } })
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("dt", [
                    _c("svg", [
                      _c("use", { attrs: { "xlink:href": "#icon-dengdaixin" } })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.$t("300295")))])
                ]),
                _vm._v(" "),
                _c("p", { class: { mirrorRotateLevel: _vm.isDirection } }, [
                  _c("svg", [
                    _c("use", { attrs: { "xlink:href": "#icon-jiantou2" } })
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("dt", [
                    _c("svg", [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-shangpinxin" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.$t("300296")))])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "Product-introduction" }, [
          _c("p", { staticClass: "bold" }, [
            _c("svg", [
              _c("use", { attrs: { "xlink:href": "#icon-shangpinjieshaozuo" } })
            ]),
            _vm._v("\n        " + _vm._s(_vm.$t("300319")) + "\n        "),
            _c("svg", { staticClass: "mirrorRotateLevel" }, [
              _c("use", { attrs: { "xlink:href": "#icon-shangpinjieshaozuo" } })
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.shopMessage.description) }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "productdeta-foot" },
        [
          _vm.shopMessage.status === 1 && _vm.$route.query.isApp != 1
            ? _c(
                "van-button",
                {
                  staticClass: "bold",
                  attrs: { type: "default" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handler()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300302")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shopMessage.status === 2 && _vm.$route.query.isApp != 1
            ? _c(
                "van-button",
                {
                  staticClass: "bold alignBtn",
                  attrs: { type: "default" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handler()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300303")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.query.isApp == 1
            ? _c(
                "div",
                [
                  _vm.shopMessage.status === 1
                    ? _c(
                        "van-button",
                        {
                          staticClass: "bold",
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.handler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("300302")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shopMessage.status === 2
                    ? _c(
                        "van-button",
                        {
                          staticClass: "bold alignBtn",
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.handler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("300303")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("dl", { on: { click: _vm.handleShare } }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("dd", { staticClass: "bold" }, [
                      _vm._v(_vm._s(_vm.$t("300342")))
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "form-popup",
          attrs: { "close-on-click-overlay": false, position: "bottom" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("p", { staticClass: "Copies flex-between" }, [
            _c("span", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm.$t("300304")))
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "iconfont icon-guanbi1",
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "price",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("300305", {
                  minPrice: _vm.shopMessage.minPrice,
                  currency: _vm.shopMessage.currency.toUpperCase(),
                  maxBuyCount: _vm.shopMessage.maxBuyCount
                })
              )
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "inputBox" }, [
            _c(
              "span",
              {
                staticClass: "subtract bold inline-block",
                class: { disable: _vm.num <= 1 },
                on: { click: _vm.subtractNum }
              },
              [_vm._v("—")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("p", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.num,
                      expression: "num"
                    }
                  ],
                  attrs: { maxlength: "4", type: "text" },
                  domProps: { value: _vm.num },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.num = $event.target.value
                      },
                      _vm.handleInput
                    ]
                  }
                }),
                _vm._v("\n          " + _vm._s(_vm.$t("300306")) + "\n        ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("300318", {
                      num: _vm.numMultiply(_vm.shopMessage.minPrice, _vm.num),
                      currency: _vm.shopMessage.currency.toUpperCase()
                    })
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "add bold inline-block",
                on: { click: _vm.addNum }
              },
              [_vm._v("+")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "prizeDescribe" }, [
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t("300307", {
                    num: _vm.assetsNum,
                    currency: _vm.shopMessage.currency.toUpperCase()
                  })
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buy" },
            [
              _c(
                "van-button",
                {
                  staticClass: "bold",
                  attrs: {
                    disabled: _vm.num == "" || _vm.num == 0,
                    type: "default"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.buyShop(_vm.shopMessage.id)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300308")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.tipModel,
            callback: function($$v) {
              _vm.tipModel = $$v
            },
            expression: "tipModel"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "describe bold inline-block" }, [
            _vm._v(_vm._s(_vm.tipMessage))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.tipModel = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300309")))]
              ),
              _vm._v(" "),
              _c("van-button", { on: { click: _vm.rechargeBalance } }, [
                _vm._v(_vm._s(_vm.$t("300297")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("tips-model", {
        attrs: {
          show: _vm.tipsdialog,
          content: _vm.tipMessage,
          colseFun: _vm.closeTips
        }
      }),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.selled,
            callback: function($$v) {
              _vm.selled = $$v
            },
            expression: "selled"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "describe bold inline-block" }, [
            _vm._v(_vm._s(_vm.tipMessage))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function() {
                      _vm.selled = false
                      _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300312")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.rechargeModel,
            callback: function($$v) {
              _vm.rechargeModel = $$v
            },
            expression: "rechargeModel"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "recharge inline-block" }, [
            _vm._v(_vm._s(_vm.$t("300313")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.rechargeModel = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300286")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.buySuccess
        ? _c(
            "div",
            { staticClass: "purchase-toast" },
            [
              _c("lottie", {
                staticClass: "lottie",
                attrs: {
                  options:
                    _vm.shopMessage.status == 1 && _vm.num == 1
                      ? _vm.defaultOptions
                      : _vm.towOptions
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.tipMessage))])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "prizeModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.prizeModel,
            callback: function($$v) {
              _vm.prizeModel = $$v
            },
            expression: "prizeModel"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("img", {
              staticClass: "mirrorRotateLevel",
              attrs: {
                src: require("../../../static/images/congratulations.png"),
                alt: ""
              }
            }),
            _vm._v("\n      " + _vm._s(_vm.$t("300310")) + "\n\n      "),
            _c("img", {
              attrs: {
                src: require("../../../static/images/congratulations.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "shopName bold" }, [
            _vm._v(_vm._s(_vm.prizeMessage.snapshotTitle))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "prizeImage" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/images/Issued.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _vm.$route.query.isApp == 1
            ? _c(
                "div",
                { staticClass: "btn inline-block" },
                [
                  _c(
                    "van-button",
                    { staticClass: "bold", on: { click: _vm.showOff } },
                    [_vm._v(_vm._s(_vm.$t("300346")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.query.isApp == 1
            ? _c(
                "van-button",
                {
                  staticClass: "bold checkGift",
                  on: {
                    click: function() {
                      _vm.ViewedTakeNotes()
                      _vm.$router.push({
                        path: "/prizeHistory",
                        query: { name: 5, isApp: _vm.$route.query.isApp }
                      })
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300351")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.query.isApp != 1
            ? _c(
                "div",
                {
                  staticClass: "btn inline-block",
                  on: {
                    click: function() {
                      _vm.ViewedTakeNotes()
                      _vm.$router.push({
                        path: "/prizeHistory",
                        query: { name: 5, isApp: _vm.$route.query.isApp }
                      })
                    }
                  }
                },
                [
                  _c("van-button", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.$t("300351")))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "close" }, [
            _c("svg", { on: { click: _vm.closePrize } }, [
              _c("use", { attrs: { "xlink:href": "#icon-guanbi2" } })
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "iconfont icon-fenxiang" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12fe62d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12fe62d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/purchase/Productdetails.vue
// module id = U+D5
// module chunks = 0